import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
// Simple Line Icons — moved from public/css/ to src/assets/css/ so webpack
// resolves the font url() paths relative to src/assets/font/ automatically.
import '@/assets/css/variables.css';
import '@/assets/css/icons.css';
import { apiBaseUrl, buildApiUrl } from './utils/api';

const app = createApp(App);

// ── Global: static asset base path (for images, fonts, js)
// Equals publicPath: '/' in dev, '/striglia/' in production build.
app.config.globalProperties.$baseUrl = process.env.BASE_URL || '/';

// ── Global: API base URL (for all fetch() calls to PHP endpoints)
// Configured via VUE_APP_API_BASE_URL in .env files.
// Access in any component as: this.apiBaseUrl
app.config.globalProperties.apiBaseUrl = apiBaseUrl;

// ── Global: helper to build a full API URL
// Access in any component as: this.$api('/path/to/file.php')
app.config.globalProperties.$api = buildApiUrl;

app.use(router).use(vuetify).mount('#app');
